import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-reports',
    template: `
        <ng-template #template>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="512" height="512" [ngClass]="class">
          <path d="M86,6L32,6c-7.2,0-13,5.8-13,13v90c0,7.2,5.8,13,13,13h64c7.2,0,13-5.8,13-13V29c0-6.1-2.4-11.9-6.7-16.3S92.1,6,86,6z M48,92c0,1.7-1.3,3-3,3h-8c-1.7,0-3-1.3-3-3V74c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3V92z M71,92c0,1.7-1.3,3-3,3h-8 c-1.7,0-3-1.3-3-3V54c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3V92z M94,92c0,1.7-1.3,3-3,3h-8c-1.7,0-3-1.3-3-3V64c0-1.7,1.3-3,3-3h8 c1.7,0,3,1.3,3,3V92z M96,26c-3.9,0-7-3.1-7-7l0-6.7c3.4,0.6,6.5,2.2,9,4.7c2.5,2.5,4.1,5.6,4.7,9H96z" fill="currentColor" />
        </svg>
        </ng-template>
    `,
})
export class IconReportComponent {
    @Input() fill: boolean = false;
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
